const apiUrl = process.env.API_URL || 'http://localhost:3001';

export default apiUrl;
